import { useState, useEffect, useCallback } from 'react';

import API from '../API';

//Default values when creating a new tenant
const initOrganization = {
    "id": 0,
    "name": '',
    "printOrderEnabled": true,
    "printArticleEnabled": true,
    "printLabelEnabled": false,
    "maxPrinterModels": 2,
    "maxPCLPrinters": 2,
    "maxLabels": 4,
    "maxUsers": 3,
    "maxWidgets": 0,
    "importEnabled": false,
    "quickPrintEnabled": false,
    "organizationSettingsEnabled": true,
    "labelVersionControlEnabled": false,
    "myArticlesEnabled": true,
    "myOrdersEnabled": true,
    "myLabelsEnabled": true,
    "pdfEnabled": true,
    "pdfOnly": false,
    "subscriptionType": 1,
    "standardLabelsEnabled": false,
    "globalCountersEnabled": false,
    "sendToGroupEnabled": false
}

// A deep link like /organization/abc carries an id that can never resolve —
// treat it as "not found" without hitting the API. Only guards a present,
// non-empty, non-numeric string that isn't "new".
const isUnresolvableOrgId = (orgId) =>
    typeof orgId === 'string' && orgId !== '' && orgId !== 'new' && !/^\d+$/.test(orgId);

export const useOrganization = (orgId)=> {
    const [organization, setOrganization] = useState('');
    const [subscriptionTypes, setSubscriptionTypes] = useState([]);
    const [error, setError] = useState('');
    const [notFound, setNotFound] = useState(false);
    const [loading, setLoading] = useState(false);
    const [warning, setWarning] = useState("");

    const getOrganization = useCallback(async ()=>{
        setLoading(true);
        setError('');
        setNotFound(false);
        try {
            if(orgId==='new'){
                setOrganization(initOrganization)
            }else if(isUnresolvableOrgId(orgId)){
                setNotFound(true)
            }else{
                const response = await API.getOrganization(orgId);
                const { data } = await API.getSubscriptionValues();
                if (response){
                    setOrganization(response.data)
                    console.log(data)
                    setSubscriptionTypes(data)
                }
            }
            setLoading(false);
        }catch(error){
            // A 404 means the tenant simply does not exist — show a friendly
            // "not found" state instead of the generic error page.
            if (error?.response?.status === 404) {
                setNotFound(true)
            } else {
                setError(error)
            }
            setLoading(false);
            console.log('ERROR:', error)
        }
    }, [orgId])

    // const getMaxValues= async ()=>{
    //     if (orgId > 0) {
    //         const labelResponse = await API.getMaxLabels(orgId)
    //         if (labelResponse){
    //             console.log('LabelResponse:', labelResponse)
    //             setCurrentMaxLabels(labelResponse.data)
    //         }
    //         const userResponse = await API.getMaxUsers(orgId)
    //         if (userResponse){
    //             console.log('userResponse:', userResponse)
    //             setCurrentMaxUsers(userResponse.data)
    //         }
    //         const PrinterResponse = await API.getMaxPrinters(orgId)
    //         if (PrinterResponse){
    //             console.log('PrinterResponse:', PrinterResponse)
    //             setCurrentMaxPrinters(PrinterResponse.data)
    //         }
    //         setCurrentMaxAgents(1)
    
    //       }
    // }

    useEffect(()=>{
        getOrganization(orgId);
    }, [orgId, getOrganization])

    return {
        organization,
        loading,
        error,
        notFound,
        warning,
        setLoading,
        setWarning,
        subscriptionTypes
    }
}